import { Box } from '@mui/material';

export const Tag = ({ label = 'beta' }: { label?: string }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'gx.actionBarButtonTile',
        fontSize: '8px',
        textTransform: 'uppercase',
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: 1,
        minWidth: '36px',
        px: 0.5,
        letterSpacing: '0.16px',
        height: '12px'
      }}
    >
      <span>{label}</span>
    </Box>
  );
};
